import { modifier } from 'ember-modifier';
import srcDoc from 'srcdoc-polyfill';

export default modifier((element: HTMLElement) => {
  srcDoc.set(element);
  return () => {};
});
